import { cn } from '@repo/shared-client/lib/utils'
import { useTranslation } from 'src/lib/intl/react'
import { useThemeLogos } from 'src/theme/logos'

export type LogoSymbolProps = {
  imageClassName?: string
}

const LogoSymbol = ({ imageClassName }: LogoSymbolProps) => {
  const { t } = useTranslation()
  const { symbol: picture } = useThemeLogos()
  const { w, h } = picture.img

  return (
    <picture>
      {Object.entries(picture.sources).map(([format, srcSet]) => (
        <source key={format} sizes="auto" srcSet={srcSet} type={`image/${format}`} />
      ))}
      <img
        alt={t('Spicy Friends logo')}
        className={cn('max-w-none select-none [-webkit-touch-callout:none]', imageClassName)}
        decoding="async"
        draggable={false}
        height={h}
        sizes="auto"
        src={picture.img.src}
        width={w}
      />
    </picture>
  )
}

export default LogoSymbol
